import axiosInstance from '../lib/axios';

export const fetchCategories = async () => {
    const response = await axiosInstance.get('/admin/categories');
    return response.data;
};

export const fetchCategoryById = async (id) => {
    const response = await axiosInstance.get(`/admin/categories/${id}`);
    return response.data;
};

export const createCategory = async (categoryData) => {
    try {
        const response = await axiosInstance.post('/admin/categories', categoryData);
        return response.data;
    } catch (error) {
        console.error('Error creating category:', error);
        throw error;
    }
};

export const updateCategory = async (id, categoryData) => {
    try {
        const response = await axiosInstance.put(`/admin/categories/${id}`, categoryData);
        return response.data;
    } catch (error) {
        console.error('Error updating category:', error);
        throw error;
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await axiosInstance.delete(`/admin/categories/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting category:', error);
        throw error;
    }
};